import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { ChartFormSubsection } from "modules";
import { useQueryClient } from "react-query";

type UseChartApplicationParams = {
  encounterId: string;
  chartCode: string;
  sectionId: string;
};

function useChartApplication(params: UseChartApplicationParams) {
  const { encounterId, chartCode, sectionId } = params;
  const queryClient = useQueryClient();
  return useAxiosQuery(
    ["chartApplication", { encounterId, chartCode, sectionId }],
    () =>
      axiosChartInstance.get<ChartFormSubsection[]>(
        `v1/chart-application/${encounterId}/${chartCode}/${sectionId}`
      ),
    {
      onSuccess: () =>
        queryClient.invalidateQueries([
          "chartSidebarIndicators",
          { encounterId, chartCode },
        ]),
    }
  );
}

export type { UseChartApplicationParams };
export { useChartApplication };
